import * as React from 'react'

function SvgStarIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4l3.132 4.69 5.428 1.529-3.493 4.427.223 5.635L12 18.328 6.71 20.28l.223-5.635L3.44 10.22l5.428-1.53L12 4z"
        stroke="currentColor"
        strokeWidth={1.6}
      />
    </svg>
  )
}

export default SvgStarIcon
